import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 999CF81E-71B7-48E1-8B8F-70FDE391F647
 * name image-filter-hdr
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-hdr.svg
 * tags
 * - Photography 
 * - Nature 
 */
export const ImageFilterHdrIcon = createSvgIcon(<><path d="M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z" /></>, 'ImageFilterHdrIcon');
export default ImageFilterHdrIcon